// extracted by mini-css-extract-plugin
export default {"imageContainer":"ContentfulBackgroundImage-module__imageContainer--_oj55","expandFalse":"ContentfulBackgroundImage-module__expandFalse--hzgC9"};